import { render } from "./ProductComponent.vue?vue&type=template&id=63429483&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"

import "./ProductComponent.vue?vue&type=style&index=0&id=63429483&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63429483"]])

export default __exports__